
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/genes/[slug]/variants",
      function () {
        return require("private-next-pages/genes/[slug]/variants.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/genes/[slug]/variants"])
      });
    }
  